import { CalendarEvent } from 'mini-calendar-event-types';
import { ColorScheme } from 'mini-color/lib/schema/ColorScheme';
import { getCategoriesStore } from '../store/store';
import { getColorSchemeFromPrimaryColor } from 'mini-color/lib/utils/colorSchemeGenerator';
import { getHexColorCodeForCategory } from '..';

/**
 * Function which returns the color scheme of the primary category associated with an event
 * @param event
 */
export const getPrimaryCategoryColorSchemeForEvent = (
    event: CalendarEvent,
    isDarkTheme?: boolean
): ColorScheme | null => {
    if (event?.Categories?.length === 0) {
        return null;
    }
    const categoriesLookup = getCategoriesStore().categoriesLookup;
    const category = categoriesLookup.get(getPrimaryCategoryForEvent(event))?.category;
    const primaryColor = category ? getHexColorCodeForCategory(category) : null;

    return primaryColor ? getColorSchemeFromPrimaryColor(primaryColor, isDarkTheme) : null;
};

/**
 * If later the mechanism of choosing the one category applicable for an event is changed, we just need to change this function
 */
export const getPrimaryCategoryForEvent = (event: CalendarEvent) => event?.Categories?.[0];
